import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { bindActionCreators, Dispatch } from 'redux';
import { api } from '~/services/api';
import { ApplicationState } from '~/store';
import { companyRequest, signInRequest } from '~/store/ducks/auth/actions';

interface DispatchProps {
  signInRequest(code: string): void;
  companyRequest(company: string, code: string): void;
}

type Props = DispatchProps;

class SignIn extends Component<Props> {
  componentDidMount() {
    //@ts-ignore
    const { signInRequest, companyRequest, match } = this.props;

    const login = async () => {
      try {
        const response = await api.get(
          `/v1/company/alias?company=${match.params.country_company}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: '',
            },
          },
        );

        const link = `https://idcs-f96a345674f4402caf09ebc240518ba4.identity.oraclecloud.com/oauth2/v1/authorize?client_id=${response.data.oauth_admin_id}&response_type=code&redirect_uri=${response.data.oauth_admin_redirect_uri}&scope=openid%20profile%20email%20groups%20get_groups&state=1234`;

        //@ts-ignore
        const params = window.location.search;
        const urlParams = new URLSearchParams(params);
        const code = urlParams.get('code');

        if (code !== null) {
          companyRequest(match.params.country_company, code);
        } else {
          //@ts-ignore
          window.location = link;
        }
      } catch (error) {
        toast.error(error.message);
      }
    };

    login();
  }

  render() {
    return <></>;
  }
}

const mapStateToProps = (state: ApplicationState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({ signInRequest, companyRequest }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);
